export interface IPrefetchable {
  shouldPrefetch: boolean;
}

export function instanceOfIPrefetchable(instance: any): instance is IPrefetchable {
  return instance
    && (instance.shouldPrefetch !== undefined);
}
